import { FunctionComponent, useState } from 'react';
import styles from "./SponseredUsers.module.css";
import cn from 'classnames';
import {Image} from 'react-bootstrap';
import SidebarLayout from '../../../component/common/Layout/SidebarLayout/SidebarLayout';
import CustomButton, { ButtonRadiusSize, ButtonSize, ButtonType } from '../../../component/common/CustomButton/CustomButton';
import FilterSelect from '../../../component/common/FilterSelect/FilterSelect';
import SearchInput from '../../../component/common/SearchInput/SearchInput';
import TextHeader from '../../../component/common/TextHeader/TextHeader';
import { IDifferenceType } from '../../../component/common/OverviewCard/OverviewCard';
import ProAccountsCard from '../../../component/common/ProAccountsCard/ProAccountsCard';
import { Outlet } from "react-router-dom";
import SponseredUsersTable from './component/SponseredUsersTable/SponseredUsersTable';
import { ASSESTS } from '../../../constant/assest';
import PromoteToSponsoredUser from './component/PromoteToSponsoredUser/PromoteToSponsoredUser';

const overView = [
    {title: 'Total Sponsored Users', value:'3', differenceType: IDifferenceType.INCREASE, differenceText: '2 Active Users'},
    {title: 'Active Users', value:'2', differenceType: IDifferenceType.DECREASE, differenceText: '66.7% of total'},
];

const SponseredUsers: FunctionComponent = () => {

    const [showPromoteUserToSponsored, setShowPromoteUserToSponsored] = useState(false);

    return (
        <SidebarLayout>
            <div className={cn(styles.sponseredUsersTopRow)}>
                <div className={styles.sponseredUsersHeader}>
                    <TextHeader 
                        title={'Sponsored Users Management'} 
                        summary={"Manage sponsored users"}
                        className='0'
                    />
                    <CustomButton 
                        className={styles.addNewContentBtn}
                        btnType={ButtonType.GREEN}
                        btnRadius={ButtonRadiusSize.SMALL}
                        btnSize={ButtonSize.SMALL}
                        onClick={() => {setShowPromoteUserToSponsored(true)}}
                    >
                        <Image src={ASSESTS.ADD} alt={'Promote User to  Sponsored'} /> Promote User to  Sponsored
                    </CustomButton>
                </div>
                <div className={styles.sponseredUsersCardsRow}>
                    {overView.map((item, index) => (
                        <ProAccountsCard 
                            key={`${item.title}-${index}`}
                            className={styles.sponseredUsersOverViewCard} 
                            title={item.title} 
                            value={item.value}
                            differenceType={item.differenceType} 
                            differenceText={item.differenceText} 
                            actualDifference={0}
                        />
                    ))}
                </div>
            </div>
            <div className={cn(styles.sponseredUsersBottomRow)}>
                <TextHeader 
                    title={'Current Sponsored Users'} 
                    summary='Manage all sponsored users and their promotional content'
                    className='mb-4'
                />
                <div className={styles.tableFilter}>
                    <SearchInput placeholder='Search subscriptions...' className={styles.sponseredUsersSearch}/>
                    <div className={cn(styles.tableFilter, styles.tableFilterCols)}>
                        <div className={styles.selectFilter}>
                            <FilterSelect 
                                options={[
                                    { value: "AllStatus", label: "All Status" },
                                    { value: "active", label: "Active" },
                                    { value: "inactive", label: "Inactive" },
                                ]} 
                                onSelect={(value: string): void => {
                                    
                                } } 
                                placeholder={'All Status'} 
                            />
                        </div>
                    </div>
                </div>
                <SponseredUsersTable />
            </div>
            <PromoteToSponsoredUser 
                showModal={showPromoteUserToSponsored}
                onClose={() => setShowPromoteUserToSponsored(false)} 
            />
        </SidebarLayout>
    );
};
export default SponseredUsers;